import SettingsPage from '../SettingsPage'
import Tags from './Tags'

const TagsSettings = () => (
  <SettingsPage title='Tags'>
    <Tags />
  </SettingsPage>
)

export default TagsSettings
